var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3767 6.21665H12.6387V4.74069C12.6387 2.70386 10.9856 1.05078 8.94877 1.05078C6.91195 1.05078 5.25887 2.70386 5.25887 4.74069V6.21665H4.52089C3.70911 6.21665 3.04492 6.88084 3.04492 7.69262V15.0724C3.04492 15.8842 3.70911 16.5484 4.52089 16.5484H13.3767C14.1884 16.5484 14.8526 15.8842 14.8526 15.0724V7.69262C14.8526 6.88084 14.1884 6.21665 13.3767 6.21665ZM8.94842 12.8578C8.13664 12.8578 7.47245 12.1936 7.47245 11.3818C7.47245 10.57 8.13664 9.90585 8.94842 9.90585C9.7602 9.90585 10.4244 10.57 10.4244 11.3818C10.4244 12.1936 9.7602 12.8578 8.94842 12.8578ZM6.73516 4.73931V6.21527H11.1631V4.73931C11.1631 3.51426 10.1742 2.52536 8.94911 2.52536C7.72406 2.52536 6.73516 3.51426 6.73516 4.73931Z",
    fill: "#E4AB10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.c7a6217d5ffbb8844e19a1ccaf990cca.svg";
export { ForwardRef as ReactComponent };